import Vue from "vue";
const END_POINT = "/requirement";
import moment from 'moment';

const colors = [
  "#2196F3",
  "#3F51B5",
  "#EF5350",
  "#C2185B",
  "#673AB7",
  "#00BCD4",
  "#4CAF50",
  "#FF9800",
  "#546E7A",
  "#00796B",
  "#FFCA28",
  "#8D6E63"
]

// const rnd = (a, b) => {
//   return Math.floor((b - a + 1) * Math.random()) + a;
// }

const fetchRequirementsDue = async (startDate, endDate, centerId) => {
  const params = {
    startDate,
    endDate,
    centerId
  };
  return await Vue.axios.get(END_POINT + "/due", { params }).then(response => {
    const requirements = response.data;
    return requirements2Events(requirements);
  }).catch((error) => {
    console.error(error)
  })
}

const fetchExpiringStudentCertificates = async (endDate, centerId) => {
  const params = {
    endDate,
    centerId
  };
  return await Vue.axios.get(END_POINT + "/student/expiring-certificates", { params }).then(response => {
    const requirements = response.data;
    return requirements2Events(requirements);
  }).catch((error) => {
    console.error(error)
  })
}

const fetchExpiringStaffCertificates = async (endDate, centerId) => {
  const params = {
    endDate,
    centerId
  };
  return await Vue.axios.get(END_POINT + "/staff/expiring-certificates", { params }).then(response => {
    const requirements = response.data;
    return requirements2Events(requirements);
  }).catch((error) => {
    console.error(error)
  })
}


const fetchBirtdayStudents = async (startDate, endDate) => {
  const params = {
    startDate,
    endDate,
    active: true
  };
  return await Vue.axios.get("/student/birthday", { params }).then(response => {
    const birthdays = response.data;
    return birthday2Events(birthdays);
  }).catch((error) => {
    console.error(error)
  })
}

const fetchBirtdayStaff = async (startDate, endDate) => {
  const params = {
    startDate,
    endDate,
    active: true
  };
  return await Vue.axios.get("/staff/birthday", { params }).then(response => {
    const birthdays = response.data;
    return birthday2Events(birthdays);
  }).catch((error) => {
    console.error(error)
  })
}

const requirements2Events = (requirements) => {
  const events = [];

  if (requirements && requirements.length > 0) {
    requirements.forEach(r => {
      let dueDate = r.dueDate ? moment(r.dueDate).toDate() : new Date();
      let name = `${r.studentName || r.staffName}`

      if (r.certificateExpiresOn) {
        const certificateExpiresOn = moment(r.certificateExpiresOn)
        const expired = certificateExpiresOn.isBefore(moment());
        if (expired) {
          dueDate = new Date();
          name += expired ? ' (Expired)' : '';
        }
        else {
          dueDate = certificateExpiresOn.toDate();
        }
      }

      
      events.push({
        name,
        start: dueDate,
        color: getColor(r.contactTypeId),
        timed: false,
        type: 'expiring',
        data: r
      });
    })
  }

  return events;
}

const birthday2Events = (birthdays) => {
  const events = [];

  if (birthdays && birthdays.length > 0) {
    birthdays.forEach(s => {
      let dob = moment(s.dob);
      dob.set('year', moment().get('year'))
      let name = `${s.fullName}'s Birthday!`
      const date = dob.toDate();
      
      events.push({
        name,
        start: date,
        color: getColor(0),
        timed: false,
        type: 'birthday',
        data: s
      });
    })
  }

  return events;
}

const getColor = (contactTypeId) => {
  const colorIndex = contactTypeId > 0 ? (contactTypeId % (colors.length-2))+1 : 0;
  return colors[colorIndex];
}


export {
  fetchRequirementsDue,
  fetchExpiringStudentCertificates,
  fetchExpiringStaffCertificates,
  fetchBirtdayStudents,
  fetchBirtdayStaff,
  getColor
};
